import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { FileText, ShoppingCart, ClipboardList } from "lucide-react";
import { documentAPI } from "@/lib/api";
import { toast } from "sonner";
import { DateField } from "@/components/ui/date-field";

export function DueDateDialog({ open, onClose, docId, dueDate, setDueDate, onSaved }) {
  return (
    <Dialog open={open} onOpenChange={v => { if (!v) onClose(); }}>
      <DialogContent className="max-w-sm" data-testid="duedate-dialog">
        <DialogHeader><DialogTitle>Échéance</DialogTitle></DialogHeader>
        <div className="space-y-4">
          <div>
            <Label>Date d'échéance</Label>
            <DateField value={dueDate} onChange={e => setDueDate(e.target.value)} data-testid="duedate-input" />
          </div>
          <Button
            onClick={async () => {
              try {
                await documentAPI.updateDueDate(docId, dueDate);
                toast.success("Échéance mise à jour");
                onClose();
                onSaved();
              } catch { toast.error("Erreur"); }
            }}
            className="w-full bg-slate-900 hover:bg-slate-800 text-white uppercase text-xs font-bold tracking-wider"
            data-testid="save-duedate-btn"
          >
            Enregistrer
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}

function getProformaActionVerb(action) {
  if (action === "pdf") return "imprimer";
  if (action === "email") return "envoyer";
  return "afficher";
}

export function ProformaChoiceDialog({ open, onClose, proformaChoice, onConfirm }) {
  return (
    <Dialog open={open} onOpenChange={v => !v && onClose()}>
      <DialogContent className="max-w-sm">
        <DialogHeader><DialogTitle className="text-base">Format du document</DialogTitle></DialogHeader>
        <p className="text-sm text-slate-500 mb-4">Comment souhaitez-vous {getProformaActionVerb(proformaChoice.action)} ce document ?</p>
        <div className="flex flex-col gap-2">
          {proformaChoice.docType === "proforma" && (<>
            <Button variant="outline" className="justify-start h-12 text-left" onClick={() => onConfirm("devis")} data-testid="proforma-choice-devis">
              <FileText size={16} className="mr-3 text-indigo-500" />
              <div><p className="font-medium text-sm">Devis</p><p className="text-[11px] text-slate-400">Afficher le titre "DEVIS"</p></div>
            </Button>
            <Button variant="outline" className="justify-start h-12 text-left" onClick={() => onConfirm("proforma")} data-testid="proforma-choice-proforma">
              <FileText size={16} className="mr-3 text-amber-500" />
              <div><p className="font-medium text-sm">Facture Proforma</p><p className="text-[11px] text-slate-400">Afficher le titre "FACTURE PROFORMA"</p></div>
            </Button>
          </>)}
          {proformaChoice.docType === "commande" && (<>
            <Button variant="outline" className="justify-start h-12 text-left" onClick={() => onConfirm("commande")} data-testid="commande-choice-commande">
              <ShoppingCart size={16} className="mr-3 text-indigo-500" />
              <div><p className="font-medium text-sm">Commande</p><p className="text-[11px] text-slate-400">Document commercial avec prix</p></div>
            </Button>
            <Button variant="outline" className="justify-start h-12 text-left" onClick={() => onConfirm("delivery_note")} data-testid="commande-choice-delivery">
              <ClipboardList size={16} className="mr-3 text-amber-500" />
              <div><p className="font-medium text-sm">Bon de livraison</p><p className="text-[11px] text-slate-400">Sans prix, avec zone de signature</p></div>
            </Button>
          </>)}
        </div>
      </DialogContent>
    </Dialog>
  );
}
